import { withTranslation } from '@application/i18n/with_translation';
import { Flex, Text } from '@cellula/react';
import { Title } from '@component/title.component';
import { Link } from 'react-router-dom';

export function ViewNotFound() {
	return (
		<Flex>
			<Title title={withTranslation('View.NotFound.Title')} />

			<Flex>
				<Text variant='labelSemiBold'>{withTranslation('View.NotFound.Causes')}</Text>
				<ul>
					<li>{withTranslation('View.NotFound.Causes.1')}</li>
					<li>{withTranslation('View.NotFound.Causes.2')}</li>
				</ul>

				<Text variant='labelSemiBold'>{withTranslation('View.NotFound.Actions')}</Text>
				<ul>
					<li>{withTranslation('View.NotFound.Actions.1')}</li>
					<li>
						{withTranslation('View.NotFound.Actions.2.1')} <Link to='/'>{withTranslation('View.NotFound.Actions.2.2')}</Link>
					</li>
				</ul>
			</Flex>
		</Flex>
	);
}
